import { EmptyState, EmptyStateBody, PageSection, PageSectionVariants, EmptyStateHeader, EmptyStateFooter, Panel, PanelMain, PanelMainBody, } from '@patternfly/react-core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import './home-page.css';

import { configurationTargetSelectors } from '../../store/configurationTarget/configurationTargetSlice';
import { WorkspaceTitleLogo } from '../../img';


const HomePage = () => {

    const { t } = useTranslation();
    const clientList = useSelector(configurationTargetSelectors.selectConfigurationTargetList);

    return (
        <>
            <PageSection variant={PageSectionVariants.light} className="home-page">
                <EmptyState className="home-page-container">
                    <Panel className="home-panel">
                        <PanelMain>
                            <PanelMainBody>
                                <div className="home-content">
                                    <div className="logged-out-logo">
                                        <img src={WorkspaceTitleLogo} alt="Workspace+" className="home-icon" />
                                    </div>

                                    <EmptyStateHeader titleText={<div className='home-title'>{t('appTitle.short')}</div>} color="white" />

                                    <EmptyStateFooter>
                                        {clientList && (<EmptyStateBody className=''>{t(clientList.length > 1 ? 'homePage.body.multipleTargets' : 'homePage.body.oneTarget', { appName: t('appTitle') })}</EmptyStateBody>)}
                                    </EmptyStateFooter>

                                </div>
                            </PanelMainBody>
                        </PanelMain>
                    </Panel>
                </EmptyState>
            </PageSection>
        </>
    );
}

export default HomePage;
